module.exports = __webpack_public_path__ + "media/images/items/anim-4-bd2eb7744a130b2636b4d500b8c73f64.webp";